import { CandlestickChart } from 'lucide-react'

export default {
	icon:  CandlestickChart,
	name: 'Market',
	onClick: ({ router, onClose }: any) => {
		router.push('/collect')
		onClose()
	},
	featured: true,
	filter: ({ loggedIn: _loggedIn }: any) => {
		return true
	}
}
